import React, { useState } from "react";
import {
  Image,
  StatusBar,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  View,
} from "react-native";
import Checkbox from "../components/Checkbox";
const AppLogo = require("../assets/EasyFill_logo.png");
import { useNavigation } from "@react-navigation/native";

const SignUpScreen = () => {
  const [isChecked, setIsChecked] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const navigation = useNavigation();

  const signIn = () => {
    navigation.navigate("Login");
  };

  const signUp = () => {
    {
      email &&
        password.length >= 4 &&
        isChecked === true &&
        navigation.navigate("Identity");
    }
  };

  return (
    <View style={styles.signUp}>
      <Image source={AppLogo} style={styles.signUpImage} />
      <Text style={styles.signUpTitle}>Sign Up</Text>
      <Text style={styles.signUpText}>
        Register your account to be able to use.
      </Text>

      <View style={styles.signUpInput}>
        <Text style={styles.signUpInputText}>Email</Text>
        <TextInput
          autoCapitalize="none"
          autoCorrect={false}
          placeholder="email@email.com"
          keyboardType="email-address"
          style={styles.signUpInputTextInput}
          onChangeText={(email) => setEmail(email)}
          defaultValue={email}
        />
      </View>

      <View style={styles.signUpInput}>
        <Text style={styles.signUpInputText}>Password</Text>
        <TextInput
          autoCapitalize="none"
          autoCorrect={false}
          secureTextEntry={true}
          placeholder="your password here"
          style={styles.signUpInputTextInput}
          onChangeText={(password) => setPassword(password)}
          defaultValue={password}
        />
      </View>

      <View style={styles.signUpTerms}>
        <Checkbox
          isChecked={isChecked}
          onPress={() => {
            setIsChecked(!isChecked);
          }}
        />
        <View>
          <Text style={styles.signUpTermsText}>
            I agree to the{" "}
            <span style={{ color: "#ff2828" }}>Terms of Service</span> and{" "}
            <span style={{ color: "#ff2828" }}>Privacy Policy</span>
          </Text>
        </View>
      </View>

      <TouchableOpacity onPress={signUp}>
        <View style={styles.signUpButton}>
          <Text style={styles.signUpButtonText}>Sign Up</Text>
        </View>
      </TouchableOpacity>

      <View style={styles.signUpMore}>
        <Text style={styles.signUpForgotPassword}>Have an Account?</Text>

        <TouchableOpacity onPress={signIn}>
          <View>
            <Text style={styles.signUpSignUpText}>Sign In</Text>
          </View>
        </TouchableOpacity>
      </View>
    </View>
  );
};

export default SignUpScreen;

const styles = StyleSheet.create({
  signUp: {
    flex: 1,
    backgroundColor: "#F8F8F8",
    paddingTop: StatusBar.currentHeight,
    paddingHorizontal: "15%",
  },
  signUpImage: {
    width: "30vw",
    height: "30vw",
    resizeMode: "contain",
    marginTop: 50,
    marginHorizontal: "auto",
  },
  signUpTitle: {
    fontSize: 30,
    fontWeight: "500",
    marginTop: 50,
  },
  signUpText: {
    fontSize: 16,
    marginBottom: 20,
  },
  signUpInput: {
    marginBottom: 20,
  },
  signUpInputText: {
    color: "#FF2828",
    fontSize: 16,
    fontWeight: "500",
  },
  signUpInputTextInput: {
    fontSize: 16,
    fontWeight: "500",
    placeholderTextColor: "#bbb",
    borderBottomWidth: 1,
    borderBottomColor: "#bbb",
    marginTop: 10,
  },
  signUpTerms: {
    flexDirection: "row",
    alignItems: "center",
  },
  signUpTermsText: {
    fontSize: 16,
    marginLeft: 10,
    fontWeight: "500",
    width: "68vw",
  },
  signUpButton: {
    backgroundColor: "#FF2828",
    paddingVertical: 10,
    alignItems: "center",
    borderRadius: 5,
    marginTop: 20,
  },
  signUpButtonText: {
    color: "#F8F8F8",
    fontWeight: "500",
    fontSize: 16,
  },
  signUpMore: {
    justifyContent: "space-between",
    flexDirection: "row",
    marginTop: 20,
  },
  signUpForgotPassword: {
    fontSize: 16,
    color: "#bbb",
    fontWeight: "500",
  },
  signUpSignUpText: {
    fontSize: 18,
    color: "#FF2828",
    fontWeight: "500",
  },
});
